module.exports = __webpack_public_path__ + "img/service1.b79992b3.svg";